import { createAction, props } from '@ngrx/store';

export const LoginAction = createAction(
  'LOGIN',
  props<{ username: string; password: string }>()
);

export const LoginSuccessAction = createAction(
  'LOGIN_SUCCESS',
  props<{ payload: {}}>()
);

export const LoginFailAction = createAction(
  'LOGIN_FAIL',
  props<{payload:{}}>()
);

export const LogoutAction = createAction(
  'LOGOUT'
);